import {
  NEIGHBORHOOD,
  NEIGHBORHOOD_ERROR,
  CLEAN_NEIGHBORHOOD,
  CLEAN_NEIGHBORHOOD_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function neighborhoodReducer(state = initialState, action) {
  switch (action.type) {
    case NEIGHBORHOOD:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case NEIGHBORHOOD_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_NEIGHBORHOOD:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_NEIGHBORHOOD_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
